// src/hooks/forms/useFormLanguage.js

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getInitialLanguage, isArabicLanguage } from "../../utils/forms/languageHelper";

/**
 * ✅ Custom hook for form language management
 * 
 * @returns {Object} - Language state and helpers
 */
const useFormLanguage = () => {
    const { i18n } = useTranslation();
    const isArabic = isArabicLanguage(i18n);

    const [activeLang, setActiveLang] = useState(getInitialLanguage());

    const showArabic = activeLang === "ar";
    const showEnglish = activeLang === "en";

    return {
        i18n,
        isArabic,
        activeLang,
        setActiveLang,
        showArabic,
        showEnglish,
    };
};

export default useFormLanguage;
